// src/config.ts
// Import images for StudyIn
// src/config.ts
// Import images for StudyIn
import StudyIn0 from "./Assets/Commercial/StudyIn/StudyIn0.jpg";
import StudyIn1 from "./Assets/Commercial/StudyIn/StudyIn1.jpg";
import StudyIn2 from "./Assets/Commercial/StudyIn/StudyIn2.jpg";
import StudyIn3 from "./Assets/Commercial/StudyIn/StudyIn3.jpg";
import StudyIn4 from "./Assets/Commercial/StudyIn/StudyIn4.jpg";
import StudyIn5 from "./Assets/Commercial/StudyIn/StudyIn5.jpg";
import StudyIn6 from "./Assets/Commercial/StudyIn/StudyIn6.jpg";
import StudyIn7 from "./Assets/Commercial/StudyIn/StudyIn7.jpg";
import StudyIn8 from "./Assets/Commercial/StudyIn/StudyIn8.jpg";
import StudyIn9 from "./Assets/Commercial/StudyIn/StudyIn9.jpg";
import StudyIn10 from "./Assets/Commercial/StudyIn/StudyIn10.jpg";
import StudyIn11 from "./Assets/Commercial/StudyIn/StudyIn11.jpg";
import StudyIn12 from "./Assets/Commercial/StudyIn/StudyIn12.jpg";
import StudyIn13 from "./Assets/Commercial/StudyIn/StudyIn13.jpg";
import StudyIn14 from "./Assets/Commercial/StudyIn/StudyIn14.jpg";
import StudyIn15 from "./Assets/Commercial/StudyIn/StudyIn15.jpg";
import StudyIn16 from "./Assets/Commercial/StudyIn/StudyIn16.jpg";
import StudyIn17 from "./Assets/Commercial/StudyIn/StudyIn17.jpg";

//daranek
import Daranek0 from "./Assets/Commercial/DaranekDetem/DaranekDetem0.jpg";
import Daranek1 from "./Assets/Commercial/DaranekDetem/DaranekDetem1.jpg";
import Daranek2 from "./Assets/Commercial/DaranekDetem/DaranekDetem2.jpg";
import Daranek3 from "./Assets/Commercial/DaranekDetem/DaranekDetem3.jpg";
import Daranek4 from "./Assets/Commercial/DaranekDetem/DaranekDetem4.jpg";

//plody
import PlodyWork0 from "./Assets/Commercial/PlodyWork/PlodyWork0.jpg";
import PlodyWork1 from "./Assets/Commercial/PlodyWork/PlodyWork1.jpg";
import PlodyWork2 from "./Assets/Commercial/PlodyWork/PlodyWork2.jpg";
import PlodyWork3 from "./Assets/Commercial/PlodyWork/PlodyWork3.jpg";
import PlodyWork4 from "./Assets/Commercial/PlodyWork/PlodyWork4.jpg";
import PlodyWork5 from "./Assets/Commercial/PlodyWork/PlodyWork5.jpg";
import PlodyWork6 from "./Assets/Commercial/PlodyWork/PlodyWork6.jpg";

// Import images for 100LetCharity
import LetCharity0 from "./Assets/Commercial/100LetCharity/100LetCharity0.jpg";
import LetCharity1 from "./Assets/Commercial/100LetCharity/100LetCharity1.jpg";
import LetCharity2 from "./Assets/Commercial/100LetCharity/100LetCharity2.jpg";
import LetCharity3 from "./Assets/Commercial/100LetCharity/100LetCharity3.jpg";
import LetCharity4 from "./Assets/Commercial/100LetCharity/100LetCharity4.jpg";
import LetCharity5 from "./Assets/Commercial/100LetCharity/100LetCharity5.jpg";
import LetCharity6 from "./Assets/Commercial/100LetCharity/100LetCharity6.jpg";

// Infinit
import InfinitSolutions0 from "./Assets/Commercial/InfinitSolutions/Infinit0.jpg";
import InfinitSolutions1 from "./Assets/Commercial/InfinitSolutions/Infinit1.jpg";
import InfinitSolutions2 from "./Assets/Commercial/InfinitSolutions/Infinit2.jpg";
import InfinitSolutions3 from "./Assets/Commercial/InfinitSolutions/Infinit3.jpg";
import InfinitSolutions4 from "./Assets/Commercial/InfinitSolutions/Infinit4.jpg";
import InfinitSolutions5 from "./Assets/Commercial/InfinitSolutions/Infinit5.jpg";
import InfinitSolutions6 from "./Assets/Commercial/InfinitSolutions/Infinit6.jpg";
import InfinitSolutions7 from "./Assets/Commercial/InfinitSolutions/Infinit7.jpg";
import InfinitSolutions8 from "./Assets/Commercial/InfinitSolutions/Infinit8.jpg";
import InfinitSolutions9 from "./Assets/Commercial/InfinitSolutions/Infinit9.jpg";
import InfinitSolutions10 from "./Assets/Commercial/InfinitSolutions/Infinit10.jpg";
import InfinitSolutions11 from "./Assets/Commercial/InfinitSolutions/Infinit11.jpg";
import InfinitSolutions12 from "./Assets/Commercial/InfinitSolutions/Infinit12.jpg";
import InfinitSolutions13 from "./Assets/Commercial/InfinitSolutions/Infinit13.jpg";

//Lejaan
import Lejaan0 from "./Assets/Commercial/Lejaan/Lejaan0.jpg";
import Lejaan1 from "./Assets/Commercial/Lejaan/Lejaan1.jpg";
import Lejaan2 from "./Assets/Commercial/Lejaan/Lejaan2.jpg";
import Lejaan3 from "./Assets/Commercial/Lejaan/Lejaan3.jpg";
import Lejaan4 from "./Assets/Commercial/Lejaan/Lejaan4.jpg";
import Lejaan5 from "./Assets/Commercial/Lejaan/Lejaan5.jpg";
import Lejaan6 from "./Assets/Commercial/Lejaan/Lejaan6.jpg";
import Lejaan7 from "./Assets/Commercial/Lejaan/Lejaan7.jpg";
import Lejaan8 from "./Assets/Commercial/Lejaan/Lejaan8.jpg";
import Lejaan9 from "./Assets/Commercial/Lejaan/Lejaan9.jpg";
import Lejaan10 from "./Assets/Commercial/Lejaan/Lejaan10.jpg";
import Lejaan11 from "./Assets/Commercial/Lejaan/Lejaan11.jpg";
import Lejaan12 from "./Assets/Commercial/Lejaan/Lejaan12.jpg";
import Lejaan13 from "./Assets/Commercial/Lejaan/Lejaan13.jpg";
import Lejaan14 from "./Assets/Commercial/Lejaan/Lejaan14.jpg";

//ozvi-se
import OzviSe0 from "./Assets/Commercial/OzviSe/OzviSe0.jpg";
import OzviSe1 from "./Assets/Commercial/OzviSe/OzviSe1.jpg";
import OzviSe2 from "./Assets/Commercial/OzviSe/OzviSe2.jpg";
import OzviSe3 from "./Assets/Commercial/OzviSe/OzviSe3.jpg";
import OzviSe4 from "./Assets/Commercial/OzviSe/OzviSe4.jpg";
import OzviSe5 from "./Assets/Commercial/OzviSe/OzviSe5.jpg";
import OzviSe6 from "./Assets/Commercial/OzviSe/OzviSe6.jpg";
import OzviSe7 from "./Assets/Commercial/OzviSe/OzviSe7.jpg";
import OzviSe8 from "./Assets/Commercial/OzviSe/OzviSe8.jpg";
import OzviSe9 from "./Assets/Commercial/OzviSe/OzviSe9.jpg";

//nice
import Nice0 from "./Assets/Commercial/Nice/Nice0.jpg";
import Nice1 from "./Assets/Commercial/Nice/Nice1.jpg";
import Nice2 from "./Assets/Commercial/Nice/Nice2.jpg";
import Nice3 from "./Assets/Commercial/Nice/Nice3.jpg";
import Nice4 from "./Assets/Commercial/Nice/Nice4.jpg";
import Nice5 from "./Assets/Commercial/Nice/Nice5.jpg";
import Nice6 from "./Assets/Commercial/Nice/Nice6.jpg";
import Nice7 from "./Assets/Commercial/Nice/Nice7.jpg";

//czech team
import ThisIs0 from "./Assets/Commercial/ThisIs/Jan0.jpg";
import ThisIs1 from "./Assets/Commercial/ThisIs/Jan1.jpg";
import ThisIs2 from "./Assets/Commercial/ThisIs/Jan2.jpg";
import ThisIs3 from "./Assets/Commercial/ThisIs/Jan3.jpg";
import ThisIs4 from "./Assets/Commercial/ThisIs/Jan4.jpg";
import ThisIs5 from "./Assets/Commercial/ThisIs/Jan5.jpg";
import ThisIs6 from "./Assets/Commercial/ThisIs/Jan6.jpg";
import ThisIs7 from "./Assets/Commercial/ThisIs/Jan7.jpg";
import ThisIs8 from "./Assets/Commercial/ThisIs/Jan8.jpg";
import ThisIs9 from "./Assets/Commercial/ThisIs/Jan9.jpg";
import ThisIs10 from "./Assets/Commercial/ThisIs/Jan10.jpg";
import ThisIs11 from "./Assets/Commercial/ThisIs/Jan11.jpg";
import ThisIs12 from "./Assets/Commercial/ThisIs/Jan12.jpg";
import ThisIs13 from "./Assets/Commercial/ThisIs/Jan13.jpg";
import ThisIs14 from "./Assets/Commercial/ThisIs/Jan14.jpg";
import ThisIs15 from "./Assets/Commercial/ThisIs/Jan15.jpg";

//pojď-padlovat
import PojdPadlovat0 from "./Assets/Commercial/Pojd/Pojd0.jpg";
import PojdPadlovat1 from "./Assets/Commercial/Pojd/Pojd1.jpg";
import PojdPadlovat2 from "./Assets/Commercial/Pojd/Pojd2.jpg";
import PojdPadlovat3 from "./Assets/Commercial/Pojd/Pojd3.jpg";
import PojdPadlovat4 from "./Assets/Commercial/Pojd/Pojd4.jpg";
import PojdPadlovat5 from "./Assets/Commercial/Pojd/Pojd5.jpg";
import PojdPadlovat6 from "./Assets/Commercial/Pojd/Pojd6.jpg";
// Import images for Toothbrush
import Toothbrush1 from "./Assets/MusicVideo/Toothbrush/Toothbrush1.jpg";
import Toothbrush2 from "./Assets/MusicVideo/Toothbrush/Toothbrush2.jpg";
import Toothbrush3 from "./Assets/MusicVideo/Toothbrush/Toothbrush3.jpg";
import Toothbrush4 from "./Assets/MusicVideo/Toothbrush/Toothbrush4.jpg";
import Toothbrush5 from "./Assets/MusicVideo/Toothbrush/Toothbrush5.jpg";
import Toothbrush6 from "./Assets/MusicVideo/Toothbrush/Toothbrush6.jpg";
import Toothbrush7 from "./Assets/MusicVideo/Toothbrush/Toothbrush7.jpg";
import Toothbrush8 from "./Assets/MusicVideo/Toothbrush/Toothbrush8.jpg";

//Stale-som
import StaleSom0 from "./Assets/MusicVideo/StaleSom/StaleSom0.jpg";
import StaleSom1 from "./Assets/MusicVideo/StaleSom/StaleSom1.jpg";
import StaleSom2 from "./Assets/MusicVideo/StaleSom/StaleSom2.jpg";
import StaleSom3 from "./Assets/MusicVideo/StaleSom/StaleSom3.jpg";
import StaleSom4 from "./Assets/MusicVideo/StaleSom/StaleSom4.jpg";
import StaleSom5 from "./Assets/MusicVideo/StaleSom/StaleSom5.jpg";
import StaleSom6 from "./Assets/MusicVideo/StaleSom/StaleSom6.jpg";
import StaleSom7 from "./Assets/MusicVideo/StaleSom/StaleSom7.jpg";
import StaleSom8 from "./Assets/MusicVideo/StaleSom/StaleSom8.jpg";
import StaleSom9 from "./Assets/MusicVideo/StaleSom/StaleSom9.jpg";
import StaleSom10 from "./Assets/MusicVideo/StaleSom/StaleSom10.jpg";
import StaleSom11 from "./Assets/MusicVideo/StaleSom/StaleSom11.jpg";
import StaleSom12 from "./Assets/MusicVideo/StaleSom/StaleSom12.jpg";
import StaleSom13 from "./Assets/MusicVideo/StaleSom/StaleSom13.jpg";
import StaleSom14 from "./Assets/MusicVideo/StaleSom/StaleSom14.jpg";
import StaleSom15 from "./Assets/MusicVideo/StaleSom/StaleSom15.jpg";
import StaleSom16 from "./Assets/MusicVideo/StaleSom/StaleSom16.jpg";
import StaleSom17 from "./Assets/MusicVideo/StaleSom/StaleSom17.jpg";
import StaleSom18 from "./Assets/MusicVideo/StaleSom/StaleSom18.jpg";
import StaleSom19 from "./Assets/MusicVideo/StaleSom/StaleSom19.jpg";
import StaleSom20 from "./Assets/MusicVideo/StaleSom/StaleSom20.jpg";
import StaleSom21 from "./Assets/MusicVideo/StaleSom/StaleSom21.jpg";
import StaleSom22 from "./Assets/MusicVideo/StaleSom/StaleSom22.jpg";
import StaleSom23 from "./Assets/MusicVideo/StaleSom/StaleSom23.jpg";
import StaleSom24 from "./Assets/MusicVideo/StaleSom/StaleSom24.jpg";
import StaleSom25 from "./Assets/MusicVideo/StaleSom/StaleSom25.jpg";
//BORN
import Born0 from "./Assets/Film/Born/Zrozena0.png";
import Born1 from "./Assets/Film/Born/Zrozena1.png";
import Born2 from "./Assets/Film/Born/Zrozena2.png";
import Born3 from "./Assets/Film/Born/Zrozena3.png";
import Born4 from "./Assets/Film/Born/Zrozena4.png";
import Born5 from "./Assets/Film/Born/Zrozena5.png";
import Born6 from "./Assets/Film/Born/Zrozena6.png";
import Born7 from "./Assets/Film/Born/Zrozena7.png";
import Born8 from "./Assets/Film/Born/Zrozena8.png";
import Born9 from "./Assets/Film/Born/Zrozena9.png";

//Sandeep
import Sandeep0 from "./Assets/Film/Sandeep/Sandeep0.jpg";
import Sandeep1 from "./Assets/Film/Sandeep/Sandeep1.jpg";
import Sandeep2 from "./Assets/Film/Sandeep/Sandeep2.jpg";
import Sandeep3 from "./Assets/Film/Sandeep/Sandeep3.jpg";
import Sandeep4 from "./Assets/Film/Sandeep/Sandeep4.jpg";
import Sandeep5 from "./Assets/Film/Sandeep/Sandeep5.jpg";
import Sandeep6 from "./Assets/Film/Sandeep/Sandeep6.jpg";
import Sandeep7 from "./Assets/Film/Sandeep/Sandeep7.jpg";
import Sandeep8 from "./Assets/Film/Sandeep/Sandeep8.jpg";
import Sandeep9 from "./Assets/Film/Sandeep/Sandeep9.jpg";
import Sandeep10 from "./Assets/Film/Sandeep/Sandeep10.jpg";
import Sandeep11 from "./Assets/Film/Sandeep/Sandeep11.jpg";
import Sandeep12 from "./Assets/Film/Sandeep/Sandeep12.jpg";
import Sandeep13 from "./Assets/Film/Sandeep/Sandeep13.jpg";
import Sandeep14 from "./Assets/Film/Sandeep/Sandeep14.jpg";
import Sandeep15 from "./Assets/Film/Sandeep/Sandeep15.jpg";
import Sandeep16 from "./Assets/Film/Sandeep/Sandeep16.jpg";
import Sandeep17 from "./Assets/Film/Sandeep/Sandeep17.jpg";
import Sandeep18 from "./Assets/Film/Sandeep/Sandeep18.jpg";
import Sandeep19 from "./Assets/Film/Sandeep/Sandeep19.jpg";
import Sandeep20 from "./Assets/Film/Sandeep/Sandeep20.jpg";

//Amori
import Amori0 from "./Assets/Film/Amori/Amori0.jpg";
import Amori1 from "./Assets/Film/Amori/Amori1.jpg";
import Amori2 from "./Assets/Film/Amori/Amori2.jpg";
import Amori3 from "./Assets/Film/Amori/Amori3.jpg";
import Amori4 from "./Assets/Film/Amori/Amori4.jpg";
import Amori5 from "./Assets/Film/Amori/Amori5.jpg";
import Amori6 from "./Assets/Film/Amori/Amori6.jpg";
import Amori7 from "./Assets/Film/Amori/Amori7.jpg";
import Amori8 from "./Assets/Film/Amori/Amori8.jpg";
import Amori9 from "./Assets/Film/Amori/Amori9.jpg";
import Amori10 from "./Assets/Film/Amori/Amori10.jpg";
import Amori11 from "./Assets/Film/Amori/Amori11.jpg";
import Amori12 from "./Assets/Film/Amori/Amori12.jpg";
import Amori13 from "./Assets/Film/Amori/Amori13.jpg";
import Amori14 from "./Assets/Film/Amori/Amori14.jpg";
import Amori15 from "./Assets/Film/Amori/Amori15.jpg";
import Amori16 from "./Assets/Film/Amori/Amori16.jpg";
import Amori17 from "./Assets/Film/Amori/Amori17.jpg";
import Amori18 from "./Assets/Film/Amori/Amori18.jpg";
import Amori19 from "./Assets/Film/Amori/Amori19.jpg";
import Amori20 from "./Assets/Film/Amori/Amori20.jpg";
import Amori21 from "./Assets/Film/Amori/Amori21.jpg";
import Amori22 from "./Assets/Film/Amori/Amori22.jpg";
import Amori23 from "./Assets/Film/Amori/Amori23.jpg";
import Amori24 from "./Assets/Film/Amori/Amori24.jpg";
import Amori25 from "./Assets/Film/Amori/Amori25.jpg";
import Amori26 from "./Assets/Film/Amori/Amori26.jpg";
import Amori27 from "./Assets/Film/Amori/Amori27.jpg";
import Amori28 from "./Assets/Film/Amori/Amori28.jpg";
import Amori29 from "./Assets/Film/Amori/Amori29.jpg";
import Amori30 from "./Assets/Film/Amori/Amori30.jpg";
import Amori31 from "./Assets/Film/Amori/Amori31.jpg";
import Amori32 from "./Assets/Film/Amori/Amori32.jpg";

//trpezlivost
import Trpezlivost0 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost0.jpg";
import Trpezlivost1 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost1.jpg";
import Trpezlivost2 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost2.jpg";
import Trpezlivost3 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost3.jpg";
import Trpezlivost4 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost4.jpg";
import Trpezlivost5 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost5.jpg";
import Trpezlivost6 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost6.jpg";
import Trpezlivost7 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost7.jpg";
import Trpezlivost8 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost8.jpg";
import Trpezlivost9 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost9.jpg";
import Trpezlivost10 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost10.jpg";
import Trpezlivost11 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost11.jpg";
import Trpezlivost13 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost13.jpg";
import Trpezlivost14 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost14.jpg";
import Trpezlivost15 from "./Assets/MusicVideo/Trpezlivost/Trpezlivost15.jpg";
import Trpezlivost16 from "./Assets/MusicVideo/Trpezlivost/Trzezlivost16.jpg";

import What0 from "./Assets/MusicVideo/WhatUWant/What0.jpg";
import What1 from "./Assets/MusicVideo/WhatUWant/What1.jpg";
import What2 from "./Assets/MusicVideo/WhatUWant/What2.jpg";
import What3 from "./Assets/MusicVideo/WhatUWant/What3.jpg";
import What4 from "./Assets/MusicVideo/WhatUWant/What4.jpg";
import What5 from "./Assets/MusicVideo/WhatUWant/What5.jpg";
import What6 from "./Assets/MusicVideo/WhatUWant/What6.jpg";
import What7 from "./Assets/MusicVideo/WhatUWant/What7.jpg";
import What8 from "./Assets/MusicVideo/WhatUWant/What8.jpg";
import What9 from "./Assets/MusicVideo/WhatUWant/What9.jpg";
import What10 from "./Assets/MusicVideo/WhatUWant/What10.jpg";
import What11 from "./Assets/MusicVideo/WhatUWant/What11.jpg";
import What12 from "./Assets/MusicVideo/WhatUWant/What12.jpg";
import What13 from "./Assets/MusicVideo/WhatUWant/What13.jpg";
import What14 from "./Assets/MusicVideo/WhatUWant/What14.jpg";
import What15 from "./Assets/MusicVideo/WhatUWant/What15.jpg";
import What16 from "./Assets/MusicVideo/WhatUWant/What16.jpg";
import What17 from "./Assets/MusicVideo/WhatUWant/What17.jpg";
import What18 from "./Assets/MusicVideo/WhatUWant/What18.jpg";
import What19 from "./Assets/MusicVideo/WhatUWant/What19.jpg";
import What20 from "./Assets/MusicVideo/WhatUWant/What20.jpg";
import What21 from "./Assets/MusicVideo/WhatUWant/What21.jpg";

//preDni

import PreDni0 from "./Assets/MusicVideo/PreDni/PreDni0.jpg";
import PreDni1 from "./Assets/MusicVideo/PreDni/PreDni1.jpg";
import PreDni2 from "./Assets/MusicVideo/PreDni/PreDni2.jpg";
import PreDni3 from "./Assets/MusicVideo/PreDni/PreDni3.jpg";
import PreDni4 from "./Assets/MusicVideo/PreDni/PreDni4.jpg";
import PreDni5 from "./Assets/MusicVideo/PreDni/PreDni5.jpg";
import PreDni6 from "./Assets/MusicVideo/PreDni/PreDni6.jpg";
import PreDni7 from "./Assets/MusicVideo/PreDni/PreDni7.jpg";
import PreDni8 from "./Assets/MusicVideo/PreDni/PreDni8.jpg";
import PreDni9 from "./Assets/MusicVideo/PreDni/PreDni9.jpg";
import PreDni10 from "./Assets/MusicVideo/PreDni/PreDni10.jpg";
import PreDni11 from "./Assets/MusicVideo/PreDni/PreDni11.jpg";
import PreDni12 from "./Assets/MusicVideo/PreDni/PreDni12.jpg";
import PreDni13 from "./Assets/MusicVideo/PreDni/PreDni13.jpg";
import PreDni14 from "./Assets/MusicVideo/PreDni/PreDni14.jpg";
import PreDni15 from "./Assets/MusicVideo/PreDni/PreDni15.jpg";
import PreDni16 from "./Assets/MusicVideo/PreDni/PreDni16.jpg";
import PreDni17 from "./Assets/MusicVideo/PreDni/PreDni17.jpg";
import PreDni18 from "./Assets/MusicVideo/PreDni/PreDni18.jpg";
import PreDni19 from "./Assets/MusicVideo/PreDni/PreDni19.jpg";
import PreDni20 from "./Assets/MusicVideo/PreDni/PreDni20.jpg";
import PreDni21 from "./Assets/MusicVideo/PreDni/PreDni21.jpg";
import PreDni22 from "./Assets/MusicVideo/PreDni/PreDni22.jpg";
import PreDni23 from "./Assets/MusicVideo/PreDni/PreDni23.jpg";
import PreDni24 from "./Assets/MusicVideo/PreDni/PreDni24.jpg";
import PreDni26 from "./Assets/MusicVideo/PreDni/PreDni26.jpg";
import PreDni27 from "./Assets/MusicVideo/PreDni/PreDni27.jpg";
import PreDni28 from "./Assets/MusicVideo/PreDni/PreDni28.jpg";
import PreDni29 from "./Assets/MusicVideo/PreDni/PreDni29.jpg";
import PreDni30 from "./Assets/MusicVideo/PreDni/PreDni30.jpg";
import PreDni31 from "./Assets/MusicVideo/PreDni/PreDni31.jpg";
import PreDni32 from "./Assets/MusicVideo/PreDni/PreDni32.jpg";
import PreDni33 from "./Assets/MusicVideo/PreDni/PreDni33.jpg";
import PreDni34 from "./Assets/MusicVideo/PreDni/PreDni34.jpg";

// Project setup interface
export interface ProjectSetupProps {
  video?: string;
  images?: any[]; // Array of imported images
  headerProps?: {
    type: string;
    name: string;
    dir: string;
    redir: string;
  };
  projects?: {
    name: string;
    key: string;
    dir: string;
    thumbnail?: any; // Imported thumbnail image
  }[];
}

// Define a placeholder for missing images
export const PLACEHOLDER_IMAGE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFegJToJBqHwAAAABJRU5ErkJggg==";

// Project configurations with directly imported images
export const projectSetups: { [key: string]: ProjectSetupProps } = {
  // Film Projects
  filmProjects: {
    headerProps: {
      type: "film",
      name: "Film Projects",
      dir: "",
      redir: "",
    },
    projects: [
      {
        name: "amori dolori",
        key: "amori",
        dir: "Valeria Recman",
        thumbnail: Amori0,
      },
      {
        name: "Sandeep!",
        dir: "Paolo Gentilella",
        key: "sandeep",
        thumbnail: Sandeep0,
      },

      {
        name: "i was born from burning apples",
        key: "born",
        dir: "Karolína Brabcová",
        thumbnail: Born0,
      },
    ],
  },

  amori: {
    video:
      "https://player.vimeo.com/video/751644405?h=41f1df4007&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    headerProps: {
      type: "film",
      name: "amori dolori",
      dir: "Valeria Recman",
      redir: "film",
    },
    images: [
      Amori1,
      Amori2,
      Amori3,
      Amori4,
      Amori5,
      Amori6,
      Amori7,
      Amori8,
      Amori9,
      Amori10,
      Amori11,
      Amori12,
      Amori13,
      Amori14,
      Amori15,
      Amori16,
      Amori17,
      Amori18,
      Amori19,
      Amori20,
      Amori21,
      Amori22,
      Amori23,
      Amori24,
      Amori25,
      Amori26,
      Amori27,
      Amori28,
      Amori29,
      Amori30,
      Amori31,
      Amori32,
    ],
  },

  sandeep: {
    video: "https://player.vimeo.com/video/961068332?h=e94c9a0d40",
    headerProps: {
      type: "film",
      name: "Sandeep!",
      dir: "Paolo Gentilella",
      redir: "film",
    },
    images: [
      Sandeep1,
      Sandeep2,
      Sandeep3,
      Sandeep4,
      Sandeep5,
      Sandeep6,
      Sandeep7,
      Sandeep8,
      Sandeep9,
      Sandeep10,
      Sandeep11,
      Sandeep12,
      Sandeep13,
      Sandeep14,
      Sandeep15,
      Sandeep16,
      Sandeep17,
      Sandeep18,
      Sandeep19,
      Sandeep20,
    ],
  },

  born: {
    video: "https://player.vimeo.com/video/987654321", // Replace it with actual URL
    headerProps: {
      type: "film",
      name: "i was born from burning apples",
      dir: "Karolína Brabcová",
      redir: "film",
    },
    images: [Born1, Born2, Born3, Born4, Born5, Born6, Born7, Born8, Born9],
  },

  // Commercial Projects
  commercialProjects: {
    headerProps: {
      type: "commercial",
      name: "Commercial Projects",
      dir: "",
      redir: "",
    },
    projects: [
      {
        name: "infinit solutions",
        key: "infinit-solutions",
        dir: "Tomáš Fiala + Petr Silovský",
        thumbnail: InfinitSolutions0,
      },
      {
        name: "lejaan",
        key: "lejaan",
        dir: "Tomáš Fiala",
        thumbnail: Lejaan0,
      },
      {
        name: "study in",
        key: "studyIn",
        dir: "Bartłomiej Klimsza",
        thumbnail: StudyIn0, // Use the first image as a thumbnail
      },
      {
        name: "#ozvise",
        key: "ozvi-se",
        dir: "Valeria Recman",
        thumbnail: OzviSe0, // Use the first image as a thumbnail
      },
      {
        name: "nice",
        key: "nice",
        dir: "Paolo Gentilella",
        thumbnail: Nice0, // Use the first image as a thumbnail
      },
      {
        name: "THIS IS CZECH TEAM UNIFORM FOR PARIS 2024",
        key: "this-is-czech-team-uniform-for-paris-2024",
        dir: "Tomáš Fiala",
        thumbnail: ThisIs0, // Use the first image as a thumbnail
      },
      {
        name: "pojď pádlovat",
        key: "pojd-padlovat",
        dir: "Jakub Veselý",
        thumbnail: PojdPadlovat0, // Use the first image as a thumbnail
      },
      {
        name: "100 let charity",
        key: "100-let-charity",
        dir: "Valeria Recman",
        thumbnail: LetCharity0,
      },
      {
        name: "daránek dětem",
        key: "daranek-detem",
        dir: "Valeria Recman",
        thumbnail: Daranek0,
      },
      {
        name: "plody.work",
        key: "plody-work",
        dir: "Valeria Recman",
        thumbnail: PlodyWork0,
      },
    ],
  },

  studyIn: {
    video: "https://player.vimeo.com/video/751669090?h=4664764a5e",
    headerProps: {
      type: "commercial",
      name: "study in",
      dir: "Bartłomiej Klimsza",
      redir: "commercial",
    },
    // Use the ordered images array as seen in the StudyIn.tsx component
    images: [
      StudyIn1,
      StudyIn2,
      StudyIn3,
      StudyIn4,
      StudyIn5,
      StudyIn6,
      StudyIn7,
      StudyIn8,
      StudyIn9,
      StudyIn10,
      StudyIn11,
      StudyIn12,
      StudyIn13,
      StudyIn14,
      StudyIn15,
      StudyIn16,
      StudyIn17,
    ],
  },

  "100-let-charity": {
    video: "https://player.vimeo.com/video/765824969?h=248a949c54",
    headerProps: {
      type: "commercial",
      name: "100 let charity",
      dir: "Valeria Recman",
      redir: "commercial",
    },

    images: [
      LetCharity1,
      LetCharity2,
      LetCharity3,
      LetCharity4,
      LetCharity5,
      LetCharity6,
    ],
  },

  nice: {
    video: "",
    headerProps: {
      type: "commercial",
      name: "nice",
      dir: "Paolo Gentilella",
      redir: "commercial",
    },

    images: [Nice1, Nice2, Nice3, Nice4, Nice5, Nice6, Nice7],
  },

  lejaan: {
    video: "https://player.vimeo.com/video/1028353511?h=427a24cb10",
    headerProps: {
      type: "commercial",
      name: "lejaan",
      dir: "Tomáš Fiala",
      redir: "commercial",
    },

    images: [
      Lejaan1,
      Lejaan2,
      Lejaan3,
      Lejaan4,
      Lejaan5,
      Lejaan6,
      Lejaan7,
      Lejaan8,
      Lejaan9,
      Lejaan10,
      Lejaan11,
      Lejaan12,
      Lejaan13,
      Lejaan14,
    ],
  },

  "infinit-solutions": {
    video: "https://player.vimeo.com/video/751669090?h=4664764a5e",
    headerProps: {
      type: "commercial",
      name: "infinit solutions",
      dir: "Tomáš Fiala + Petr Silovský",
      redir: "commercial",
    },

    images: [
      InfinitSolutions1,
      InfinitSolutions2,
      InfinitSolutions3,
      InfinitSolutions4,
      InfinitSolutions5,
      InfinitSolutions6,
      InfinitSolutions7,
      InfinitSolutions8,
      InfinitSolutions9,
      InfinitSolutions10,
      InfinitSolutions11,
      InfinitSolutions12,
      InfinitSolutions13,
    ],
  },

  "this-is-czech-team-uniform-for-paris-2024": {
    video: "",
    headerProps: {
      type: "commercial",
      name: "This is Czech Team Uniform for Paris 2024",
      dir: "Tomáš Fiala",
      redir: "commercial",
    },

    images: [
      ThisIs0,
      ThisIs1,
      ThisIs2,
      ThisIs3,
      ThisIs4,
      ThisIs5,
      ThisIs6,
      ThisIs7,
      ThisIs8,
      ThisIs9,
      ThisIs10,
      ThisIs11,
      ThisIs12,
      ThisIs13,
      ThisIs14,
      ThisIs15,
    ],
  },

  "pojd-padlovat": {
    video: "",
    headerProps: {
      type: "commercial",
      name: "pojď pádlovat",
      dir: "Jakub Veselý",
      redir: "commercial",
    },

    images: [
      PojdPadlovat1,
      PojdPadlovat2,
      PojdPadlovat3,
      PojdPadlovat4,
      PojdPadlovat5,
      PojdPadlovat6,
    ],
  },

  "daranek-detem": {
    video: "",
    headerProps: {
      type: "commercial",
      name: "daránek dětem",
      dir: "Valeria Recman",
      redir: "commercial",
    },

    images: [Daranek1, Daranek2, Daranek3, Daranek4],
  },

  "ozvi-se": {
    video: "",
    headerProps: {
      type: "commercial",
      name: "#ozvise",
      dir: "Valeria Recman",
      redir: "commercial",
    },

    images: [
      OzviSe1,
      OzviSe2,
      OzviSe3,
      OzviSe4,
      OzviSe5,
      OzviSe6,
      OzviSe7,
      OzviSe8,
      OzviSe9,
    ],
  },

  "plody-work": {
    video: "",
    headerProps: {
      type: "commercial",
      name: "plody.work",
      dir: "Valeria Recman",
      redir: "commercial",
    },

    images: [
      PlodyWork1,
      PlodyWork2,
      PlodyWork3,
      PlodyWork4,
      PlodyWork5,
      PlodyWork6,
    ],
  },

  // Music Video Projects
  musicVideoProjects: {
    headerProps: {
      type: "music video",
      name: "Music Video Projects",
      dir: "",
      redir: "",
    },
    projects: [
      {
        name: "stále som (16mm)",
        key: "stale-som",
        dir: "Tomáš Fiala",
        thumbnail: StaleSom0,
      },
      {
        name: "trpezlivosť",
        key: "trpezlivost",
        dir: "Tomáš Fiala",
        thumbnail: Trpezlivost0,
      },
      {
        name: "pre dni",
        key: "pre-dni",
        dir: "Tomáš Fiala",
        thumbnail: PreDni0,
      },
      {
        name: "what u want?",
        key: "what-u-want",
        dir: "Tomáš Fiala",
        thumbnail: What0,
      },
      {
        name: "toothbrush",
        key: "toothbrush",
        dir: "Aleš Valtr",
        thumbnail: Toothbrush1,
      },
    ],
  },

  toothbrush: {
    video: "https://player.vimeo.com/video/762895107?h=2e9ee3f4c1",
    headerProps: {
      type: "music video",
      name: "toothbrush",
      dir: "Aleš Valtr",
      redir: "music-video",
    },
    images: [
      Toothbrush8,
      Toothbrush2,
      Toothbrush3,
      Toothbrush4,
      Toothbrush6,
      Toothbrush5,
      Toothbrush7,
    ],
  },
  "stale-som": {
    video: "",
    headerProps: {
      type: "music video",
      name: "Stále som (16mm)",
      dir: "Tomáš Fiala",
      redir: "music-video",
    },
    images: [
      StaleSom1,
      StaleSom2,
      StaleSom3,
      StaleSom4,
      StaleSom5,
      StaleSom6,
      StaleSom7,
      StaleSom8,
      StaleSom9,
      StaleSom10,
      StaleSom11,
      StaleSom12,
      StaleSom13,
      StaleSom14,
      StaleSom15,
      StaleSom16,
      StaleSom17,
      StaleSom18,
      StaleSom19,
      StaleSom20,
      StaleSom21,
      StaleSom22,
      StaleSom23,
      StaleSom24,
      StaleSom25,
    ],
  },
  trpezlivost: {
    video: "https://player.vimeo.com/video/1060120998?h=b9cdf3d267",
    headerProps: {
      type: "music video",
      name: "trpezlivosť",
      dir: "Tomáš Fiala",
      redir: "music-video",
    },
    images: [
      Trpezlivost1,
      Trpezlivost2,
      Trpezlivost3,
      Trpezlivost4,
      Trpezlivost5,
      Trpezlivost6,
      Trpezlivost7,
      Trpezlivost8,
      Trpezlivost9,
      Trpezlivost10,
      Trpezlivost11,
      Trpezlivost13,
      Trpezlivost14,
      Trpezlivost15,
      Trpezlivost16,
    ],
  },
  "pre-dni": {
    video: "",
    headerProps: {
      type: "music video",
      name: "pre dni",
      dir: "Tomáš Fiala",
      redir: "music-video",
    },
    images: [
      PreDni1,
      PreDni2,
      PreDni3,
      PreDni4,
      PreDni5,
      PreDni6,
      PreDni7,
      PreDni8,
      PreDni9,
      PreDni10,
      PreDni11,
      PreDni12,
      PreDni13,
      PreDni14,
      PreDni15,
      PreDni16,
      PreDni17,
      PreDni18,
      PreDni19,
      PreDni20,
      PreDni21,
      PreDni22,
      PreDni23,
      PreDni24,
      PreDni26,
      PreDni27,
      PreDni28,
      PreDni29,
      PreDni30,
      PreDni31,
      PreDni32,
      PreDni33,
      PreDni34,
    ],
  },
  "what-u-want": {
    video: "",
    headerProps: {
      type: "music video",
      name: "what u want?",
      dir: "Tomáš Fiala",
      redir: "music-video",
    },
    images: [
      What1,
      What2,
      What3,
      What4,
      What5,
      What6,
      What7,
      What8,
      What9,
      What10,
      What11,
      What12,
      What13,
      What14,
      What15,
      What16,
      What17,
      What18,
      What19,
      What20,
      What21,
    ],
  },

  // Simple Collections
  home: {},
};
